//
//
//
//
//
//
//
//
//
//

  import { downLoadLink } from '@/controller/basic'

export default {
    name: 'downLoad',
    data() {
      return {
        link: ''
      }
    },
    mounted() {
      this.getLink()
    },
    computed: {
      isWx() {
        let ua = window.navigator.userAgent
        return ua.toLowerCase().indexOf('micromessenger') !== -1
      }
    },
    methods: {
      clickLink(e) {
        if (navigator.userAgent.match(/android/i)) {
          if (this.isWx) {
            e.preventDefault()
            this.$vux.alert.show({
              content: `请点击右上角“...”<br/>并选择打开浏览器进行下载`
            })
          }
        } else {
          e.preventDefault()
          window.open('https://itunes.apple.com/cn/app//id1450803780?mt=8')
        }
      },
      // 获取app下载地址
      getLink() {
        downLoadLink({
          callback: res => {
            this.link = res.data.releaseUrl
          }
        })
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/downLoad.vue